export default __webpack_public_path__ + "static/media/logotype-white.9ba99d57.svg";